export default __webpack_public_path__ + "static/media/alpharadar-watchlist-large.b15bfdf4.jpg";